module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/android-chrome-512x512-c50a2c2f41bae61291049fb9a1684472.png";